import {SelectWithoutContainer} from "../../component/Select/Select";
import {useEffect, useState} from "react";
import {TextInputWithoutContainer} from "../../component/TextInput/TextInput";
import Loading from "../../component/Loading/Loading";
import {isManagerLoggedIn, login} from "./functions";
import {useNavigate} from "react-router-dom";

const Login = () => {
    const navigate = useNavigate()
    const [isLoading , setIsLoading] = useState(false);
    const [loginForm , setLoginForm] = useState({
        username : "",
        password : "",
        role : "MANAGER",
    });
    const roleOptions = [
        {
            label : "مدیر" ,
            value : "MANAGER" ,
        }, {
            label: "نویسنده",
            value: "REPORTER",
        }
    ];

    const handleSubmit = async () => {
        setIsLoading(true);
        if (await login(loginForm)){
            navigate(0)
        }


        setIsLoading(false);
    }


    if (isLoading)
        return <Loading />

    return (
        <main className="d-flex w-100">
            <div className="container d-flex flex-column">
                <div className="row vh-100">
                    <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto d-table h-100">
                        <div className="d-table-cell align-middle">

                            <div className="text-center mt-4">
                                <h1 className="h2">خوش برگشتی!</h1>
                                <p className="lead mt-2 mb-4">
                                    جهت برگشت مجدد به پنل، اطلاعات کاربری خودتان را وارد کنید.

                                </p>
                            </div>

                            <div className="card">
                                <div className="card-body">
                                    <div className="m-sm-3">
                                        <form>
                                            <div className="mb-3">
                                                <TextInputWithoutContainer label={"نام کاربری"} id={"username"} value={loginForm.username} onChange={(value) => {
                                                    setLoginForm({...loginForm , username : value})
                                                }} />
                                            </div>
                                            <div className="mb-3">
                                                <TextInputWithoutContainer label={"رمز عبور"} id={"password"} type={"password"} value={loginForm.password} onChange={(value) => {
                                                    setLoginForm({...loginForm , password : value})
                                                }} />
                                            </div>
                                            <div>
                                                <SelectWithoutContainer label={"نوع کاربری"} options={roleOptions} onChange={(value) => {
                                                    setLoginForm({...loginForm , role : value})
                                                }} />
                                            </div>

                                            <div className="d-grid gap-2 mt-3">
                                                <button className={"btn btn-primary"} disabled={isLoading} onClick={handleSubmit}>ورود</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}


export default Login;